function addZero(i) {
	if (i < 10) {
		i = "0" + i;
	}
	return i;
}

if ($(".js-brandSlider").length > 0) {
	var sliderCounterCurrent = $(".brand-slider .js-sliderCounterCurrent"),
		sliderCounterFull = $(".brand-slider .js-sliderCounterFull"),
		progressSlider = $(".js-progressSlider"),
		brandLinks = $(".js-brandLinks"),
		ww = $(window).width();

	$(".brand-slider__image").each(function () {
		var _this = $(this);

		if (_this.hasClass("has_card")) {
			var img = _this.find("img").data("img");

			if (ww < 1024 && ww > 767) {
				img = _this.find("img").data("img-tablet");
			}

			if (ww < 768) {
				img = _this.find("img").data("img-mobile");
			}

			_this.find("img").attr("src", img);
		} else {
			var img = _this.data("img");

			_this.css("background-image", "url(" + img + ")");
		}
	});

	sliderCounterFull.html(addZero($(".js-brandSlider .swiper-slide").length));
	var speedSlider = 1300;

	if (ww < 1024) {
		speedSlider = 600;
	}

	var boxColorsSlider = new Swiper(".js-boxColorsSlider .swiper-container", {
		slidesPerView: 1,
		direction: "vertical",
		loop: true,
		speed: speedSlider,
	});

	var brandSlider = new Swiper(".js-brandSlider .swiper-container", {
		slidesPerView: 1,
		loop: true,
		autoplay: {
			delay: 8000,
			disableOnInteraction: false,
		},
		navigation: {
			nextEl: ".js-brandSlider .swiper-next",
			prevEl: ".js-brandSlider .swiper-prev",
		},
		speed: speedSlider,
		on: {
			init: function () {
				progressSlider.addClass("is-active");
			},
		},
	});

	brandSlider.on("slideChange", function () {
		sliderCounterCurrent.text(addZero(this.realIndex + 1));

		progressSlider.removeClass("is-active");

		brandLinks.removeClass("slide_index_1 slide_index_2 slide_index_3");

		brandLinks.addClass("slide_index_" + (+this.realIndex + 1));

		$(".brand-slider__subtitle").removeClass(
			"slide_index_1 slide_index_2 slide_index_3"
		);
		$(".brand-slider__subtitle")
			.eq(+this.realIndex)
			.addClass("slide_index_" + (+this.realIndex + 1));

		setTimeout(function () {
			progressSlider.addClass("is-active");
		}, 10);
	});

	brandSlider.controller.control = boxColorsSlider;
	boxColorsSlider.controller.control = brandSlider;
}

$(document).on("change", ".js-phoneMinLength", function () {
	var _this = $(this);
	var numbers = _this.val().replace(/\D+/g, "");

	if (numbers.length < 11) {
		$(".brand-form__submit button").attr("disabled", "true");

		setTimeout(function () {
			_this.addClass("error");
			_this.parent().addClass("has-error");

			_this.removeClass("valid");
			_this.parent().removeClass("has-valid");
		}, 50);
	} else {
		_this.removeClass("error");
		_this.parent().removeClass("has-error");

		$(".brand-form__submit button").removeAttr("disabled");
	}
});

var title = document.querySelector(".title");
var curs = document.querySelector(".cursor");
var brandSlider = document.querySelector(".js-brandSlider");

if (brandSlider && brandSlider.length !== 0) {
	document.addEventListener("mousemove", function (e) {
		var x = e.pageX;
		var y = e.pageY;
		curs.style.left = x - 50 + "px";
		curs.style.top = y - 50 + "px";
	});
}

$(".js-brandSlider")
	.on("mousemove", function () {
		$(".cursor").addClass("visible");
	})
	.on("mouseleave", function () {
		$(".cursor").removeClass("visible");
	});

$(".js-brandSlider .swiper-prev").on("mousemove", function () {
	$(".cursor").addClass("show-prev");
});

$(".js-brandSlider .swiper-prev").on("mouseleave", function () {
	$(".cursor").removeClass("show-prev");
});

$(".js-brandSlider .swiper-next").on("mousemove", function () {
	$(".cursor").addClass("show-next");
});

$(".js-brandSlider .swiper-next").on("mouseleave", function () {
	$(".cursor").removeClass("show-next");
});

// document.addEventListener('mouseleave', function (e) {
//   var x = e.pageX;
//   var y = e.pageY;
//   curs.style.left = x - 50 + "px";
//   curs.style.top = y - 50 + "px";
// });
